import { CardMatriculate } from '@/components/molecules/Admin/Cards/CardMatriculate'
import { drawerCreators } from '@/store/ducks/drawer'
import { useAppDispatch } from '@/store/hooks'
import cohortsService from '@/services/cohortsService'
import Spinner from '@/components/atoms/Spinner'
import { useEffect, useState } from 'react'
import { RadioGroup } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'
import classNames from 'classnames'
import Icon from '@/components/atoms/Icon'
import { CohortsModel } from '@models'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation } from 'swiper/modules'
import { TrailsCourses } from './trails'

const optionsFilterSkillsCategory = [
	{
		label: 'Todos',
		value: [],
		select: { svg: 'vertical-todos', color: 'bg-[#FFF2E6]' },
	},
	{
		label: 'Gestão de Produtos',
		value: ['Gestão de Produtos'],
		select: { svg: 'vertical-prduto-e-design', color: 'bg-[#FFECF8]' },
	},
	{
		label: 'Dados e Programação',
		value: ['Dados', 'Programação'],
		select: { svg: 'vertical-dados-e-programacao', color: 'bg-[#DED6F2]' },
	},
	{
		label: 'Gestão e Liderança',
		value: ['Inovação e Gestão'],
		select: { svg: 'vertical-gestao-e-lideranca', color: 'bg-[#DFFBEA]' },
	},
]

const optionsFilterSaberCategory = [
	{
		label: 'Todos',
		value: [],
		select: { svg: 'vertical-todos', color: 'bg-[#FFF2E6]' },
	},
	{
		label: 'Desenvolvimento Pessoal',
		value: ['Desenvolvimento Pessoal'],
		select: { svg: 'vertical-desenvolvimento-pessoal', color: 'bg-[#FEF7E2]' },
	},
	{
		label: 'Filosofia e Reflexões',
		value: ['Filosofia e Reflexões'],
		select: { svg: 'vertical-filosofia-e-reflexoes', color: 'bg-[#FFECF8]' },
	},
	{
		label: 'Inovação e Gestão',
		value: ['Inovação e Gestão'],
		select: { svg: 'vertical-gestao-e-lideranca', color: 'bg-[#DFFBEA]' },
	},
	{
		label: 'Marketing',
		value: ['Marketing'],
		select: { svg: 'vertical-marketing', color: 'bg-[#FFEEEE]' },
	},
]

interface CohortCard {
	id: number
	name: string
	'type-course': string
	total_classes: number
	produto: string
	categoria: string
	produto_nome: string
	nome_card: string
	capa_card?: string
	descricao?: string
	sobre_curso?: string
	carga_horaria?: string
	foto_professor?: string
	nome_professor?: string
	sobre_professor?: string
	units?: Array<string>
	turma?: {
		id: number
		curso_id: number
		empresa_id: number
		status: string
	}
}

export function Courses() {
	const dispatch = useAppDispatch()

	const [filterCategory, setFilterCategory] = useState<{
		[key: string]: { label?: string; value?: string[] }
	}>({})

	const { data: matriculates, isLoading } = cohortsService.getMatriculate()

	const handleDrawerInfo = (courseInfo: CohortsModel.CohortCard) => {
		const sobreCursoArray = courseInfo?.sobre_curso
			?.split('\n')
			.map((paragrafo) => paragrafo.trim())
			.filter((paragrafo) => paragrafo.length > 0)

		dispatch(
			drawerCreators.openDrawer({
				drawerInfo: {
					curso_id: courseInfo.id,
					'type-course': courseInfo['type-course'],
					turma: courseInfo.turma,
					name_course: courseInfo.nome_card,
					description_course: courseInfo.descricao,
					duration: courseInfo.carga_horaria,
					foto_professor: courseInfo.foto_professor,
					name_teacher: courseInfo.nome_professor,
					description_teacher: courseInfo.sobre_professor,
					about_course: sobreCursoArray,
					units: courseInfo.units,
				},
			})
		)
	}

	const filteredCoursesByProduct: Array<{
		product_name: string
		product: string
		courses: Array<CohortCard>
	}> =
		matriculates?.available_courses?.map((matriculateCourse) => {
			return {
				product_name: matriculateCourse.product_name,
				product: matriculateCourse.product,
				courses: matriculateCourse.courses,
			}
		}) ?? []

	const [filteredCourses, setFilteredCourses] = useState(
		filteredCoursesByProduct
	)

	function filterCategories() {
		const fluencySkillsFilter = filterCategory['fluency_skills']?.value || []
		const fluencyAmpliadoFilter = filterCategory['saber_ampliado']?.value || []

		let resultFilter = filteredCoursesByProduct

		if (fluencySkillsFilter?.length) {
			resultFilter = resultFilter.map((product) => {
				if (product.product_name === 'Fluency Skills') {
					const filteredCourses = product.courses.filter((course) =>
						fluencySkillsFilter.includes(course.categoria)
					)
					return { ...product, courses: filteredCourses }
				}
				return product
			})
		}

		if (fluencyAmpliadoFilter?.length) {
			resultFilter = resultFilter.map((product) => {
				if (product.product_name === 'Saber Ampliado') {
					const filteredCourses = product.courses.filter((course) =>
						fluencyAmpliadoFilter.includes(course.categoria)
					)
					return { ...product, courses: filteredCourses }
				}
				return product
			})
		}

		return resultFilter
	}

	useEffect(() => {
		const filtered = filterCategories()
		setFilteredCourses(filtered)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterCategory, matriculates])

	if (isLoading) {
		return (
			<div className='flex h-full w-full justify-center'>
				<Spinner />
			</div>
		)
	}

	if (!filteredCourses?.find((categories) => categories?.courses?.length)) {
		return (
			<div className='w-full mt-10 py-3 px-4 flex items-center max-w-max border border-dashed border-white/10 rounded-xl'>
				<p className='text-base text-white font-medium'>
					Nenhum curso completo no momento
				</p>
			</div>
		)
	}

	return (
		<>
			<TrailsCourses />
			<div className='mt-12 flex flex-col gap-10'>
				{filteredCourses?.map((product, key) => {
					const originalProduct = filteredCoursesByProduct.find(
						(original) => original.product_name === product.product_name
					)

					const showCourses =
						originalProduct && originalProduct?.courses?.length > 0

					return (
						showCourses && (
							<div key={key} className='flex flex-col gap-7'>
								<div className='flex flex-col gap-6'>
									<span className='text-3xl text-white leading-[100%] font-semibold'>
										{product.product_name}
									</span>
									{(() => {
										if (
											['fluency_skills', 'saber_ampliado'].includes(
												product.product
											)
										) {
											const filterOptions =
												product.product === 'saber_ampliado'
													? optionsFilterSaberCategory
													: optionsFilterSkillsCategory

											return (
												<div className='relative flex w-full items-center justify-between gap-4'>
													<RadioGroup
														value={filterCategory[product.product]?.value || []}
														onChange={(value) => {
															setFilterCategory({
																...filterCategory,
																[product.product]: {
																	...filterCategory[product.product],
																	value,
																},
															})
														}}
														className='min-w-full md:min-w-fit flex gap-2 gap-y-2 overflow-x-scroll md:overflow-clip'
													>
														{filterOptions?.map((category, key) => {
															return (
																<RadioGroup.Option
																	key={key}
																	value={category.value}
																	className={({ active, checked }) =>
																		twMerge(
																			`relative flex min-w-max gap-3 py-2 px-3 rounded-full border dark:border-[#F7F9FB]/25 text-base font-semibold text-zinc-50 leading-normal cursor-pointer items-center justify-center focus:outline-none transition-colors duration-300`,
																			classNames({
																				'border-brand-primary bg-brand-primary/15 dark:text-[#041B3A] dark:bg-white dark:font-semibold':
																					active ||
																					checked ||
																					(!category?.value?.length &&
																						!filterCategory[product.product]
																							?.value?.length),
																			})
																		)
																	}
																>
																	<div
																		className={twMerge(
																			'flex items-center justify-center w-8 h-8 rounded-full',
																			category.select.color
																		)}
																	>
																		<Icon
																			name={category.select.svg}
																			width='20'
																			height='20'
																			className='w-5 h-5'
																		/>
																	</div>

																	{category.label}
																</RadioGroup.Option>
															)
														})}
													</RadioGroup>

													<div
														className={twMerge(
															classNames(
																'hidden lg:flex w-full gap-4 justify-end',
																{
																	hidden: !product?.courses?.length,
																}
															)
														)}
													>
														<div
															className={`cursor-pointer swiper-button-prev-courses-${key} relative flex items-center justify-center after:hidden w-10 h-10 bg-brand-primary rounded-full z-10 pointer-events-auto`}
														>
															<Icon
																name='slick-arrow-right'
																width='24'
																height='24'
																className='w-[24px] h-[24px] rotate-180'
															/>
														</div>

														<div
															className={`cursor-pointer swiper-button-next-courses-${key} relative flex items-center justify-center after:hidden w-10 h-10 bg-brand-primary rounded-full z-10 pointer-events-auto`}
														>
															<Icon
																name='slick-arrow-right'
																width='24'
																height='24'
																className='w-[24px] h-[24px]'
															/>
														</div>
													</div>
												</div>
											)
										}

										return <></> // Caso contrário, não renderiza nada
									})()}
								</div>

								<div className='relative overflow-visible w-full'>
									{!product?.courses?.length ? (
										<div className='w-full py-3 px-4 flex items-center max-w-max bg-[#191122] border border-dashed border-white/10 rounded-xl'>
											<p className='text-base text-white font-medium'>
												Em breve adicionaremos novos cursos
											</p>
										</div>
									) : (
										<Swiper
											modules={[Pagination, Navigation]}
											slidesPerView='auto'
											spaceBetween={15}
											slidesPerGroup={1}
											centeredSlides={false}
											pagination={{
												clickable: false,
												dynamicBullets: false,
												el: null,
											}}
											autoHeight={true}
											watchSlidesProgress={true}
											slideToClickedSlide={true}
											grabCursor={true}
											breakpoints={{
												768: {
													slidesPerView:
														product.courses.length > 2
															? 2
															: product.courses.length,
												},
												1024: {
													slidesPerView:
														product.courses.length > 2
															? 3
															: product.courses.length,
												},
												1200: {
													slidesPerView:
														product.courses.length > 4
															? 4
															: product.courses.length,
												},
											}}
											navigation={{
												nextEl: `.swiper-button-next-courses-${key}`,
												prevEl: `.swiper-button-prev-courses-${key}`,
											}}
											className='z-0 h-full min-h-[396px] w-full !overflow-visible'
										>
											{product?.courses?.map((course, key) => (
												<SwiperSlide key={key} className='max-w-[320px]'>
													<CardMatriculate
														onClick={() => handleDrawerInfo(course)}
														course={course}
													/>
												</SwiperSlide>
											))}
										</Swiper>
									)}
								</div>
							</div>
						)
					)
				})}
			</div>
		</>
	)
}
